import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  DataSection,
  HeaderData,
  IconArrow,
  ElipsisSpan,
  BodyData
} from './style';

import { Arrow } from '../../../../assets/images';

class AccordionDataSection extends Component {
  constructor(props) {
    super(props);

    this.state = { active: false };

    this.onClick = this.onClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }

  onClick() {
    const { active } = this.state;
    this.setState({ active: !active });
  }

  handleBlur() {
    this.setState({ active: false });
  }

  handleKeyPress(e) {
    if (e.key === 'Enter' || e.key === 'Space') {
      this.onClick();
    }
  }

  render() {
    const { className, span, title, body } = this.props;
    return (
      <DataSection
        className={className}
        active={this.state.active}
        onBlur={this.handleBlur}
        span={span}
        ref={reference => {
          this.accordion = reference;
        }}
      >
        {title && (
          <HeaderData onClick={this.onClick} tabIndex={0}>
            <IconArrow
              size="xs"
              color="dark"
              svg={Arrow}
              active={this.state.active}
            />
            <ElipsisSpan active={this.state.active}>{title}</ElipsisSpan>
          </HeaderData>
        )}
        {!title && body ? (
          <BodyData active={this.state.active} withoutTitle>
            {body}
          </BodyData>
        ) : (
          <BodyData active={this.state.active}>{body}</BodyData>
        )}
      </DataSection>
    );
  }
}

AccordionDataSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  body: PropTypes.string
};

export default AccordionDataSection;
